import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { RouterHistoryService } from '~/core/services/router-history/router-history.service';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private readonly activityService: OrganizerSharedActivityService,
    private readonly routerHistoryService: RouterHistoryService
  ) {}

  public canActivate(): true {
    const currentUrl = this.routerHistoryService.current;
    const previousUrl = this.routerHistoryService.previous;
    const activity = this.activityService.activity;

    if (activity && previousUrl) {
      // /locale/module-path/... => module-path
      const currentModulePath = currentUrl.split('/')[2];

      // Is coming from an other module.
      if (!previousUrl.includes(currentModulePath)) {
        this.activityService.clearActivity();
      }
    }

    return true;
  }
}

export const OrganizerSharedClearActivityGuard: CanActivateFn = (): true => {
  return inject(PermissionsService).canActivate();
};
